import React from 'react';

/**
 * Line icons for the facts in the Version 2 collage's info panel, keyed by
 * the fact they illustrate. Drawn inline (paths ported from index3.html) so
 * they pick up the panel's text colour through `currentColor`.
 */
const ICON_PATHS = {
  // Open days — a calendar page.
  days: (
    <>
      <rect x="3" y="4.5" width="18" height="16" rx="2" />
      <path d="M16 2.5v4M8 2.5v4M3 10h18M8 14h2m4 0h2m-8 3.5h2" />
    </>
  ),
  // Courts — a court seen from above.
  courts: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="1.5" />
      <path d="M12 4v16M3 12h18M7 8h2m6 0h2m-10 8h2m6 0h2" />
    </>
  ),
  // Location — a map pin.
  location: (
    <>
      <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
};

/**
 * One fact's icon, inside the round badge the collage CSS draws around it.
 *
 * @param {object} props
 * @param {'days'|'courts'|'location'} props.name - which fact it illustrates
 * @returns {JSX.Element|null} nothing for an unknown name
 */
function CollageFeatureIcon({ name }) {
  const paths = ICON_PATHS[name];
  if (!paths) return null;
  return (
    <span className="bgc-feature-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {paths}
      </svg>
    </span>
  );
}

export default CollageFeatureIcon;
